import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    button: {
        '&:hover': {
            backgroundColor: 'var(--foreground-purple)'
        }
    }
}))
